import { useLocale } from "@/hooks/use-locale";
import { getCharacterBySlug, getCharacterDisplayName } from "@/lib/characters";

interface Props {
  fullName: string;
  slug: string;
  className?: string;
}

const letterMap: Record<string, string> = {
  "liam-lion": "L",
  "fabio-fox": "F",
  "kaleb-koala": "K",
  "clyde-crocodile": "C",
  "dana-deer": "D",
  "casper-crab": "C",
};

const AlliterativeName = ({ fullName, slug, className = "" }: Props) => {
  const { currentLang } = useLocale();

  // For zh/ja, render the localized name directly without alliteration coloring
  if (currentLang === "zh" || currentLang === "ja") {
    const character = getCharacterBySlug(slug);
    const localized = character ? getCharacterDisplayName(character, currentLang) : fullName;
    return <span className={className}>{localized}</span>;
  }

  const letter = letterMap[slug];
  if (!letter) return <span className={className}>{fullName}</span>;

  const words = fullName.split(" ");

  return (
    <span className={className}>
      {words.map((word, i) => {
        const isMatch = word[0]?.toUpperCase() === letter;
        return (
          <span key={i}>
            {i > 0 && " "}
            {isMatch ? (
              <>
                <span className="text-accent">{word[0]}</span>
                {word.slice(1)}
              </>
            ) : (
              word
            )}
          </span>
        );
      })}
    </span>
  );
};

export default AlliterativeName;
